import { createStyles, makeStyles } from '@material-ui/core';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
import React from 'react';
import { projectName } from '../../config';

const themeSettings = { name: 'LoginPageLogo' };

export type LoginPageLogoProps = {
  className?: string;
};

export type LoginPageLogoClassNameKey = 'root';

const useStyles = makeStyles(() =>
  createStyles<LoginPageLogoClassNameKey, {}>({
    root: {
      display: 'block', // kills the inline-baseline gap under the img
      width: '100%',
      maxWidth: '310px', // same footprint width as the old logo
      height: 'auto',
    },
  }),
);

const LoginPageLogo = React.forwardRef<HTMLImageElement, LoginPageLogoProps>(() => {
  const classes = useStyles();
  return <img src={`/${projectName}/mainLogo.png`} alt='logo' className={classes.root} />;
});

LoginPageLogo.displayName = 'LoginPageLogo';

export default withThemeProps(themeSettings)(LoginPageLogo);
